<template>
  <div :class="orientation"
       class="search-filter-group">
    <ul v-if="groupFilters != null">
      <li v-for="(filter, index) in groupFilters"
          :key="filter.name">
        <div class="filter">
          <div class="filter-content">
            <component
              :is="filterTemplates[formatFilterType(filter.type)]"
              v-model="filter.value"
              :filter-object="filter"
              :filter="filter.alias"
              :config="filter.config"
              :group="filter.group"
              :options="filter.options"
              :collapsible="collapsible"
              :show-filter-names="showFilterNames"
              :index="index"
              :sort-alpha="sortAlpha">
            </component>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { camelCase } from "lodash";
import { mapState } from "vuex";

export default {
  components: {},

  props: {
    additionalProperties: {
      type: Array,
      default: () => [],
    },
    orientation: {
      type: String,
      default: "vertical",
      validator: value => {
        let isValid;

        switch ( value ) {
          case "horizontal":
          case "vertical":
            isValid = true;
            break;
          default:
            isValid = false;
        }

        return isValid;
      },
    },
    filterGroup: {
      type: String,
      default: "default",
    },
    collapsible: {
      type: Boolean,
      default: true,
    },
    showFilterNames: {
      type: Boolean,
      default: true,
    },
    sortAlpha: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      filterTemplates: {
        textbox: () => import( "~/Components/Search/Filters/Textbox.vue" ),
        checkboxes: () => import( "~/Components/Search/Filters/Checkboxes.vue" ),
        radiobuttons: () => import( "~/Components/Search/Filters/Radiobuttons.vue" ),
        letters: () => import( "~/Components/Search/Filters/Letters.vue" ),
        slider: () => import( "~/Components/Search/Filters/Slider.vue" ),
        dropdown: () => import( "~/Components/Search/Filters/Dropdown.vue" ),
        date: () => import( "~/Components/Search/Filters/Datepicker.vue" ),
        tabs: () => import( "~/Components/Search/Filters/Tabs.vue" ),
      },
    };
  },
  computed: {
    groupFilters () {
      let result;

      if ( this.filters.length > 0 ) {
        const foundFilters = this.filters.filter( x => x.group === this.filterGroup );

        result = foundFilters;
      } else {
        result = [];
      }

      return result;
    },
    ...mapState( {
      filters: state => state.search.filters,
      openAllFilters: state => state.search.openAllFilters,
    } ),
  },
  created () {
    if ( this.collapsible && this.groupFilters.length > 0 ) {
      this.groupFilters.forEach( el => {
        if ( this.openAllFilters ) {
          this.openFilters.push( el.alias );
        }
      } );
    }
  },

  methods: {
    formatFilterType ( filterType ) {
      let formattedFilterType = filterType;

      formattedFilterType = formattedFilterType.replace( /\s/g, "" );

      return camelCase( formattedFilterType );
    },
  },
};
</script>
